// proteoformMatrix.ts

// Derive the Tau matrix from the composite proteoform_name (e.g. "N-0N-pT205-3R-C").
// Segments are hyphen-delimited; compound PTM tokens (e.g. "pS202+PT205") contain a
// "+" rather than a "-", so a plain split on "-" preserves them.
// TODO(backend): SampleProteoformPublic does not expose per-isoform/PTM presence; this
// derivation is a stand-in until the API returns structured tokens. Confirm the exact
// delimiter for compound tokens in proteoform_name.
export function parseProteoformName(name: string | null | undefined): Set<string> {
  if (name === null || name === undefined || name === '') return new Set<string>();
  return new Set(name.split('-').filter(segment => segment.length > 0));
}
